import { useSelectorEq } from "commons/store/common";
import { useEffect } from "react";
import type { IState } from "store/modules";
import { apiPguideViewFlag } from "store/modules/auth/authR";
import { useApi } from "store/modules/common";

export const useGuideStepCheck = () => {
  const { step } = useSelectorEq((state: IState) => ({
    step: state.auth.guide.step,
  }));

  return { step };
};

/**
 * 가이드 확인 완료 api
 * @returns
 */
export const useGuideViewComplete = () => {
  const { apiResult } = useApi();

  const complete = async () => {
    try {
      await apiResult(apiPguideViewFlag);
    } catch (error) {
      throw new Error("API Error: apiPguideViewFlag");
    }
  };

  return { complete };
};
